import PropTypes from 'prop-types';

export const StructuredTextPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    type: PropTypes.string.isRequired,
    text: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    spans: PropTypes.array
  }).isRequired
);

export const DOCUMENT_TYPES = {
  ARTICLE: 'article',
  HUB: 'hub',
  PERSON: 'person',
  NAVIGATION: 'navigation',
  MODAL: 'modal'
};

export const ARTICLE_DATA_TYPES = {
  TITLE: 'title',
  DECK: 'deck',
  HUB_PAGE: 'hub_page',
  AUTHORS: 'authors',
  SEO_IMAGE: 'seo_image',
  ARTICLE_TYPE: 'article_type',
  PODCAST_EMBED: 'podcast_embed',
  WEBINAR_EMBED: 'webinar_embed',
  WEBINAR_RSVP_LINK: 'webinar_rsvp_link',
  DISPLAY_DATE: 'display_date',
  SEO_DESCRIPTION: 'seo_description',
  SEO_TITLE: 'seo_title',
  LOCKED_CONTENT_MODAL: 'locked_content_modal'
};

export const HUB_DATA_TYPES = {
  TITLE: 'title',
  HUB_PAGE: 'hub_page'
};

export const NAVIGATION_DATA_TYPES = {
  TITLE: 'title',
  LINKS: 'links'
};

export const PERSON_DATA_TYPES = {
  AVATAR: 'avatar',
  BIO: 'bio',
  FULL_NAME: 'full_name',
  JOB_TITLE: 'job_title'
};

export const MODAL_DATA_TYPES = {
  HEADLINE: 'headline',
  SUBCOPY: 'subcopy',
  PERMISSION_TYPES: 'permission_types',
  BULLET_POINTS: 'bullet_points',
  CTA_COPY: 'cta_copy',
  CTA_LINK: 'cta_link',
  TESTIMONIAL_PROFILE_PHOTO: 'testimonial_profile_photo',
  TESTIMONIAL_NAME: 'testimonial_name',
  TESTIMONIAL_BIO: 'testimonial_bio',
  TESTIMONIAL_QUOTE: 'testimonial_quote',
  COPY: 'copy',
  LINK: 'link',
  CTA: 'cta'
};

export const ARTICLE_SLICE_TYPES = {
  BODY_CONTENT: 'content',
  PULL_QUOTE: 'pull_quote',
  SPLASH_PHOTO: 'splash_photo',
  HEADER: 'article_header',
  RELATED_ARTICLES_LIST: 'related_articles_list',
  FEATURED_AUTHOR: 'featured_author',
  SHARE_BAR: 'share_bar',
  NEWSLETTER_SIGNUP: 'newsletter_signup',
  TABLE: 'table',
  QUOTE: 'quote',
  ACCREDITATION: 'accreditation',
  ACTION_CALLOUT: 'action_callout',
  CUSTOM_LINKS: 'custom_links',
  PODCAST_EMBED: 'podcast_embed',
  JOIN_AS_BREEDER_CALLOUT: 'join_as_breeder_callout',
  MISSION_CALLOUT: 'mission_callout',
  LOCKED_CONTENT_MODAL: 'locked_content_modal'
};

export const ArticleGroupArticlePropTypes = PropTypes.shape({
  data: PropTypes.shape({
    seo_image: PropTypes.shape({
      alt: PropTypes.string,
      url: PropTypes.string
    }),
    deck: StructuredTextPropTypes,
    title: StructuredTextPropTypes,
    // eslint-disable-next-line react/forbid-prop-types
    authors: PropTypes.array.isRequired
  }),
  uid: PropTypes.string.isRequired
});

export const HUB_SLICE_TYPES = {
  NEWSLETTER_SIGNUP: 'newsletter_signup',
  MAGAZINE_ABOUT_CALLOUT: 'magazine_about_callout',
  ARTICLE_GROUP: 'article_group',
  ACCREDITATION: 'accreditation',
  MAGAZINE_HEADER: 'magazine_header',
  ACTION_CALLOUT: 'action_callout',
  MAGAZINE_FRONT_PAGE: 'magazine_front_page',
  CUSTOM_LINKS: 'custom_links',
  FEATURED_WEBINARS: 'featured_webinars',
  CUSTOM_LINK_INSERT: 'custom_link_insert',
  FEATURED_PODCASTS: 'featured_podcasts',
  ARTICLE_PREVIEWS_LIST: 'article_previews_list',
  PODCAST_HEADER: 'podcast_header'
};

export const AuthorPropTypes = PropTypes.shape({
  data: PropTypes.shape({
    avatar: PropTypes.shape({
      alt: PropTypes.string,
      url: PropTypes.string
    }),
    bio: PropTypes.string,
    full_name: PropTypes.string,
    job_title: PropTypes.string
  })
});

export const ImagePropTypes = PropTypes.shape({
  alt: PropTypes.string,
  dimensions: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number
  }),
  url: PropTypes.string
});

export const LinkPropTypes = PropTypes.shape({
  link_type: PropTypes.string,
  url: PropTypes.string
});

export const HubPropTypes = PropTypes.shape({
  data: PropTypes.shape({
    title: StructuredTextPropTypes
  }),
  id: PropTypes.string,
  uid: PropTypes.string
});

export const ArticlePropTypes = PropTypes.shape({
  data: PropTypes.shape({
    article_type: PropTypes.oneOf(['article', 'podcast', 'webinar']),
    authors: PropTypes.arrayOf(AuthorPropTypes),
    deck: StructuredTextPropTypes,
    display_date: PropTypes.string,
    hub_page: HubPropTypes,
    title: StructuredTextPropTypes,
    webinar_rsvp_link: LinkPropTypes
  }),
  id: PropTypes.string,
  uid: PropTypes.string
});

export const ModalPropTypes = PropTypes.shape({
  data: PropTypes.shape({
    headline: PropTypes.string,
    subcopy: PropTypes.string,
    bullet_points: PropTypes.arrayOf(
      PropTypes.shape({
        bullet_text: PropTypes.string,
        bullet_icon: PropTypes.shape({
          url: PropTypes.string
        })
      })
    ),
    // eslint-disable-next-line react/forbid-prop-types
    permission_types: PropTypes.arrayOf(PropTypes.object),
    cta_link: PropTypes.string,
    cta_copy: PropTypes.string,
    testimonial_profile_photo: PropTypes.shape({
      url: PropTypes.string
    }),
    testimonial_name: PropTypes.string,
    testimonial_bio: PropTypes.string,
    testimonial_quote: PropTypes.string
  })
});
